import { render } from "./VariantDepth.vue?vue&type=template&id=09b72210"
import script from "./VariantDepth.vue?vue&type=script&lang=js"
export * from "./VariantDepth.vue?vue&type=script&lang=js"

import exportComponent from "/home/grosscol/workspace/bravue/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__